// TODO: later fetch allowed days from API instead of config
export const DELIVERY_DAYS = {
  sunday: false,
  monday: true,
  tuesday: true,
  wednesday: true,
  thursday: true,
  friday: true,
  saturday: false,
};
